import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DOMPurify from "dompurify";
import { MemoryItem } from "./MemoryWall";

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  position: "relative",
  paddingBottom: "32px",
}));

interface Props {
  item: MemoryItem;
  onOpen: (media: string) => void;
}

const isSafeMediaUrl = (url: string) => {
  try {
    const parsed = new URL(url);
    return ["http:", "https:"].includes(parsed.protocol);
  } catch {
    return false;
  }
};

export default function MemoryCard({ item, onOpen }: Props) {
  const safeText = DOMPurify.sanitize(item.text || "");
  const safeFrom = DOMPurify.sanitize(item.from || "");
  const isMediaSafe = item.media && isSafeMediaUrl(item.media);

  return (
    <StyledCard>
      <Box sx={{ p: 2 }}>
        {item.type === "image" && isMediaSafe && (
          <Box onClick={() => onOpen(item.media!)} sx={{ cursor: "pointer" }}>
            <img
              src={item.media}
              alt={safeFrom}
              style={{ width: "100%", borderRadius: "6px" }}
            />
          </Box>
        )}

        {item.type === "video" && isMediaSafe && (
          <Box onClick={() => onOpen(item.media!)} sx={{ cursor: "pointer" }}>
            <video
              controls
              src={item.media}
              style={{ width: "100%", borderRadius: "6px" }}
            />
          </Box>
        )}

        {(item.text || item.type === "text") && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            {safeText}
          </Typography>
        )}
      </Box>

      {item.from && (
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            bottom: 6,
            right: 8,
            fontStyle: "italic",
            opacity: 0.7,
          }}
        >
          — {safeFrom}
        </Typography>
      )}
    </StyledCard>
  );
}
